<template>
    <div class="underLogoPhrase">
        <h2 class="font-weight-bold mb-4 centers">Les Animaux</h2>
        <p class="littlesize">
            Selon les dates de mise à jour, certains animaux visibles sur le site ont déjà pu être
            adoptés. N'hésitez pas à contacter les différents refuges.
        </p>
    </div>

    <div class="container-fluid">
        <div class="row responsive">
            <button class="bluenow buttonadaptatif responsive aniaml" @click="filtrerAnimaux('all')">Tous</button>
            <button class="bluenow buttonadaptatif responsive aniaml" @click="filtrerAnimaux('chien')">Chiens</button>
            <button class="bluenow buttonadaptatif responsive aniaml" @click="filtrerAnimaux('chiot')">Chiot</button>
            <button class="bluenow buttonadaptatif responsive aniaml" @click="filtrerAnimaux('chat')">Chats</button>
            <button class="bluenow buttonadaptatif responsive aniaml" @click="filtrerAnimaux('chaton')">Chatons</button>

        </div>

        <div class="row">
            <div class="col-lg-3" v-for="animau in animauxFiltres" :key="animau.id">
                <router-link :to="'/animaux/' + animau.id" class="card" style="height: auto; min-height: 350px;">
                    <div>
                        <img :src="'https://admin.asso-refuge.fr/images/' + animau.img1"
                            :alt="'photo du ' + animau.type + ' ' + animau.name + 'du refuge des berauds situé a Roman sur isères'" :class="'tailleimg'"
                            :title="animau.name + ' ' + animau.race" />
                    </div>
                    <div class="endessous" style="margin-top: 10px !important;margin-bottom: 30px;">
                        <h4 class="namedogtitleback">{{ animau.name }}</h4>
                        <h6>{{ animau.race }}</h6>
                        <h6><strong> Age: {{ calculateAge(animau.naissance) }}</strong></h6>
                        <i class="fas fa-plus-circle"></i>
                    </div>
                </router-link>
            </div>
        </div>
    </div>

</template>


<script>
import convertAge from '../components/getAge.js';

export default {
    data() {
        return {
            animaux: [],
            animauxFiltres: []
        };
    },
    mounted() {
        const idSite = this.$idSite;
        fetch(`https://admin.asso-refuge.fr/getAnimal/${idSite}`)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                // Combine all animals into a single array
                this.animaux = data
                this.appliquerFiltre();
            })
            .catch(error => {
                console.error('Il y a eu un problème avec votre requête :', error.message);
            });
    },
    methods: {
        appliquerFiltre() {
            const type = this.$route.query.type || 'all';

            if (type === 'all') {
                this.animauxFiltres = this.animaux;
            } else if (type === 'chiot') {
                this.animauxFiltres = this.animaux.filter(animal => {
                    return animal.type === 'chien' && this.getAgeInYears(animal.naissance) < 1;
                });
            } else if (type === 'chaton') {
                this.animauxFiltres = this.animaux.filter(animal => {
                    return animal.type === 'chat' && this.getAgeInYears(animal.naissance) < 1;
                });
            } else {
                this.animauxFiltres = this.animaux.filter(animal => animal.type === type);
            }
        },
        filtrerAnimaux(type) {
            this.$router.push({ path: this.$route.path, query: { type } });
        },
        calculateAge(dateOfBirth) {
            return convertAge(dateOfBirth);
        },

        getAgeInYears(dateNaissance) {
            const birthDate = new Date(dateNaissance);
            const now = new Date();
            const ageInMilliseconds = now - birthDate;
            const ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);
            return ageInYears;
        },
    },
    watch: {
        '$route.query.type': 'appliquerFiltre'
    }
};
</script>